import { MapSourceId } from '@daisi/models/map';
import { LayerSpecification } from 'maplibre-gl';

export const INCIDENT_AREA_SOURCE: MapSourceId = 'incidentArea';

export const INCIDENT_AREA_LINE_LAYER: LayerSpecification = {
  id: INCIDENT_AREA_SOURCE + '_LINE',
  type: 'line',
  source: 'incidentArea',
  paint: {
    'line-color': '#fff',
    'line-width': 2,
  },
};

export const INCIDENT_AREA_LAYER: LayerSpecification = {
  id: INCIDENT_AREA_SOURCE + '_AREA',
  type: 'fill',
  source: INCIDENT_AREA_SOURCE,
  paint: {
    'fill-color': '#000',
    'fill-opacity': 0.5,
  },
};
